export const abnPattern = /^\d{11}$/;
